<template>
  <div>
    <select
      class="form-control colSpots"
      :id="'spot_'+spot"
      v-model="localValue"
      @change="emitSelection"
    >
      <option value=""></option>
      <option v-for="col in collectionData" :key="col.id" :value="col.id">
        {{col.name}}
      </option>
    </select>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
export default {
  name: "CollectionsList",
  props: {
    spot: {
      type: [String, Number],
      required: true
    },
    selectedValue: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      localValue: ""
    };
  },
  emits: {
    updateCollectionSpot: null
  },
  computed: {
    ...mapGetters({
      'collectionData': 'product/getCollectionData',
    }),

  },
  watch: {
    selectedValue: {
      immediate: true,
      handler(value) {
        this.localValue = value === null || value === undefined ? "" : value;
      }
    }
  },
  methods: {
    emitSelection() {
      const selectedCollection = this.collectionData.find((col) => String(col.id) === String(this.localValue));
      this.$emit("updateCollectionSpot", {
        spotKey: `spot_${this.spot}`,
        value: this.localValue,
        name: selectedCollection ? selectedCollection.name : ""
      });
    }
  }
};
</script>
<style scoped>

</style>